import { SvgIcon, SvgIconProps } from '@mui/material';

const OtherIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="white"
  >
    <path d="M19 37.8889C29.432 37.8889 37.8889 29.432 37.8889 19C37.8889 8.56793 29.432 0.111084 19 0.111084C8.56793 0.111084 0.111084 8.56793 0.111084 19C0.111084 29.432 8.56793 37.8889 19 37.8889Z" />
    <g transform="translate(9 9)" fill="white">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 4H17V13H4.00003V15C4.00003 15.55 4.45003 16 5.00003 16H16L20 20V5C20 4.45 19.55 4 19 4ZM15 10V1C15 0.45 14.55 0 14 0H1.00003C0.450031 0 3.05176e-05 0.45 3.05176e-05 1V15L4.00003 11H14C14.55 11 15 10.55 15 10Z"
          fill="white"
        />
      </svg>
    </g>
  </SvgIcon>
);

export default OtherIcon;
